import React, { useEffect } from 'react'
import { ModalProvider } from 'react-modal-hook'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import ReactPixel from 'react-facebook-pixel'

import EUCalculator from '../EU/Calculator'
import GAListener from '../GAListener'
import { LocaleProvider } from '../../context/locale'
import NACalculator from '../NA/Calculator'
import RegionSelect from '../RegionSelect'
import Report from '../Report'

const Index = () => {
  useEffect(() => {
    console.log('FB pixel')
    ReactPixel.init('513870309568900', {
      autoConfig: true,
      debug: false,
    })
    ReactPixel.pageView()
  }, [])

  return (
    <React.Fragment>
      <Router>
        <GAListener trackingId={process.env.REACT_APP_GOOGLE_ANALYTICS_ID}>
          <LocaleProvider>
            <ModalProvider>
              <Switch>
                <Route path="/" exact render={() => <RegionSelect />} />
                <Route
                  path="/na"
                  render={(props) => <NACalculator {...props} />}
                />
                <Route
                  path="/eu"
                  render={(props) => <EUCalculator {...props} />}
                />
                <Route
                  path="/latam"
                  render={(props) => <EUCalculator {...props} />}
                />
                <Route
                  path="/report"
                  render={(props) => <Report {...props} />}
                />
              </Switch>
            </ModalProvider>
          </LocaleProvider>
        </GAListener>
      </Router>
    </React.Fragment>
  )
}

export default Index
